module.exports = __webpack_public_path__ + "img/icon-home-terminal.7eca8038.svg";